'use client';
import { zodResolver } from '@hookform/resolvers/zod';
import {
  Controller,
  type ControllerProps,
  FormProvider,
  useForm,
  useController,
  useFormState,
  useWatch,
  type Control,
  type FieldError,
  type FieldErrors,
  type UseFormHandleSubmit,
  type UseFormRegister,
  type UseFormRegisterReturn,
  type UseFormReset,
  type UseFormReturn,
  type UseFormTrigger,
} from 'react-hook-form';

export {
  Controller,
  type ControllerProps,
  FormProvider,
  useForm,
  useController,
  useFormState,
  useWatch,
  zodResolver,
  type Control,
  type FieldError,
  type FieldErrors,
  type UseFormHandleSubmit,
  type UseFormRegister,
  type UseFormRegisterReturn,
  type UseFormReset,
  type UseFormReturn,
  type UseFormTrigger,
};
